import React, { useEffect, useState } from "react";
import {
  FiShoppingCart,
  FiChevronDown,
  FiX,
  FiMenu,
  FiUser,
} from "react-icons/fi";
import Logo from "../../assets/logoweb.jpg";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Popup from "../User/Signup/SingupPopup";
import { CgProfile } from "react-icons/cg";
import { clearCart } from "../../redux/action/cart";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { FaSpinner } from "react-icons/fa";
import { LuMapPinned } from "react-icons/lu";
import api from "../../utils/api";
const NAV_LINKS = [
  "home",
  "menu",
  
  "orders",
  "locations",
  "contact",
  "loyalty",
  "blogs",
];

const Header = ({ activeLink, onclick }) => {
  const [popupType, setPopupType] = useState(null);
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showmap, setShowMap] = useState(true)
  const location = useLocation();
   const RestaurantSavedId =  JSON.parse(localStorage.getItem('selectedRestaurantId'))
   const [locationData, setLocationData] = useState([]);
  //  console.log("ocsjkd", locationData)
    useEffect(() => {
    const fetchData = async () => {
     
      try {
        // Simulating API call to fetch all data
        const response = await api.get(`/restaurant/${RestaurantSavedId}`);
        const results = response.data?.data || [];
        setLocationData(results); // Save full data
       
      } catch (error) {
        console.error("Error fetching restaurant data:", error);
      }
      
    };
    fetchData();
  }, [RestaurantSavedId]);
console.log('lsksldksd', location.pathname)

const dispatch = useDispatch()
const existingCart = JSON.parse(localStorage.getItem('cart')) || [];
  const toggleMobileMenu = () => setMobileMenuOpen(!isMobileMenuOpen);
  const { loading, isAuthenticated, user } = useSelector((state) => state.user);
  const { cart } = useSelector((state) => state.cart);
  const totalQuantity = cart.reduce((total, item) => total + item.quantity, 0);
  const totalQuantityExisting = existingCart?.reduce((total, item) => total + item.quantity, 0);
  useEffect(() => {
    console.log("isAuthenticated",isAuthenticated);
    if (!isAuthenticated) {
      dispatch(clearCart()); 
    }
  }, [isAuthenticated, dispatch]);
  useEffect(() => {
    setShowMap(location.pathname === "/"); // Show map icon only on home page
  }, [location.pathname]);
  // console.log("🚀 ~ Header ~ loading:", loading)
  // console.log("🚀 ~ Header ~ user:", user)
  // console.log("🚀 ~ Header ~ isAuthenticated:", isAuthenticated)
  // Show a loader or skeleton UI if loading is true
  if (loading) {
    return <div className="flex justify-center items-center min-h-screen">
    <FaSpinner className="animate-spin text-4xl text-[#AF313D] " />
  </div>
  }
  const openPopup = (type) => {
    setPopupType(null); // Close any existing popup
    setTimeout(() => setPopupType(type), 200); // Open the requested popup
  };


  const isActive = (link) => link === activeLink;
 
  return (
    <header className="bg-white body border-b border-gray-200 py-2 sticky top-0 z-50 shadow-md h-[107px]">
      <div className="container mx-auto flex items-center justify-between px-4 h-full">
        {/* Logo Section */}
        <Link to={`/${locationData?.slug || '/'}`} >
          <div className="flex items-center cursor-pointer">
            <img
              src={locationData?.logo && locationData?.logo[0] || locationData?.logo}
              alt="Levante Logo"
              className="h-[65px]  md:h-[80px] lg:h-[85px] "
            />
          </div>
        </Link>

        {/* Navigation Links */}
        <nav className="hidden md:flex space-x-4 lg:space-x-6 text-gray-700">
          {NAV_LINKS.map((link) => (
            <NavLink key={link} link={link} isActive={isActive(link)} />
          ))}
        </nav>

        {/* Cart, Profile Icon, and Sign Up/Login Button */}
        <div className="hidden md:flex items-center gap-x-4">
          {showmap && (
 <div>
 <p onClick={onclick} className=" text-[#374151] text-2xl cursor-pointer"><LuMapPinned/></p>
</div>
          )}
       
          <Link
            to="/my-cart"
            aria-label="View Cart"
            className={`relative cursor-pointer mr-[5px] ${
              isActive("my-cart") ? "text-orange-600" : "text-gray-700"
            }`}
          >
            <FiShoppingCart className="h-6 w-6" />
            <span className="absolute right-0 bottom-3 rounded-full bg-[#AF313D]  w-4 h-4 top right p-0 m-0 text-white font-mono text-[12px] leading-tight text-center">
            {cart.length > 0 ? totalQuantity  :totalQuantityExisting}
                </span>
          </Link>
        
          {isAuthenticated ? (

    <Link to='/dashboard'>
      <CgProfile
      size={32}
      className="text-gray cursor-pointer" // Default Icon Styling
      // onClick={() => console.log("Profile Clicked")} // Profile action
    />
    </Link>
) : (
  <button
    className="bg-[#AF313D] text-white w-[139px] h-[45.57px] px-4 py-2 rounded-full text-sm font-medium hover:bg-red-700"
    onClick={() => openPopup("sign-up")} // Open Sign Up popup
  >
    Sign Up / Login
  </button>
)}

        </div>

        {/* Mobile Menu Button */}
        <div className="flex md:hidden items-center space-x-4">
          <Link
            to="/my-cart"
            aria-label="View Cart"
            className={`relative cursor-pointer mr-[15px] ${
              isActive("my-cart") ? "text-[#AF313D] " : "text-gray-700" 
            }`}
          >
            <FiShoppingCart className="h-5 w-5" />
            <span className="absolute -right-1 top-0 rounded-full bg-[#AF313D]  w-3 h-3 top right p-0 m-0 text-white font-mono text-[12px] leading-tight text-center">
            {cart.length > 0 ? totalQuantity  :totalQuantityExisting}
                </span>
          </Link>
          {/* <Link
            to="/profile"
            aria-label="Profile"
            className={`${
              isActive("profile") ? "text-[#AF313D] " : "text-gray-700"
            }`}
          >
            <FiUser className="h-5 w-5" />
          </Link> */}
          <div>
          {showmap && (
 <div>
 <p onClick={onclick} className=" text-[#374151] text-2xl cursor-pointer"><LuMapPinned/></p>
</div>
          )}
          </div>
          {isAuthenticated ? (

<Link to='/dashboard'>
  <CgProfile
  size={32}
  className="text-gray cursor-pointer" // Default Icon Styling
  // onClick={() => console.log("Profile Clicked")} // Profile action
/>
</Link>
) : (
<button
className="bg-[#AF313D] text-white w-[120px] h-[45.57px] px-4 py-2 rounded-full text-sm font-medium hover:bg-red-700"
onClick={() => openPopup("sign-up")} // Open Sign Up popup
>
Sign Up / Login
</button>
)}
          <button
            onClick={toggleMobileMenu}
            aria-label="Toggle Mobile Menu"
            className="text-black text-2xl"
          >
            <FiMenu />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`fixed inset-y-0 right-0 z-50 bg-white shadow-lg p-4 flex flex-col space-y-4 md:hidden transform transition-all duration-500 ease-in-out ${
          isMobileMenuOpen
            ? "translate-x-0 scale-100 w-1/2"
            : "translate-x-full scale-75"
        }`}
      >
        <button
          onClick={toggleMobileMenu}
          className="text-xl self-end text-black"
          aria-label="Close Mobile Menu"
        >
          <FiX />
        </button>
        {NAV_LINKS.map((link) => (
          <NavLink key={link} link={link} isMobile isActive={isActive(link)} />
        ))}
      </div>

  

{popupType === "sign-up" && (
  <Popup closePopup={() => setPopupType(null)} /> // Render Login popup
)}



    </header>
  );
};


function NavLink({ link, isMobile, isActive }) {
  const selectedSlug = Cookies.get("selectedSlug");
  const linkHref =
    link === "home"
      ? `/${selectedSlug || ''}`  
      : link === "loyalty"
      ? "/loyalty-program"
      : `/${link}`;

  return (
    <Link
      to={linkHref}
      className={`${
        isMobile ? "text-lg" : "text-[12.11px] lg:text-lg"
      } font-bold ${
        isActive ? "text-[#AF313D] " : "text-gray-700"
      } hover:text-orange-600`}
    >
      {link.charAt(0).toUpperCase() + link.slice(1)}
    </Link>
  );
}


NavLink.propTypes = {
  link: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
  isActive: PropTypes.bool,
};

NavLink.defaultProps = {
  isMobile: false,
  isActive: false,
};

function Button({ variant, text, onClick }) {
  const baseClasses =
    "py-3 px-8 text-center rounded-xl border border-solid min-h-[50px] w-full max-w-[485px]";
  const variantClasses = {
    primary: "text-white bg-[#AF313D] border-[#AF313D]",
    secondary: "text-[#AF313D] border-[#AF313D] border-[3px]",
  };

  return (
    <button
      className={`${baseClasses} ${variantClasses[variant]}`}
      onClick={onClick} // Attach the onClick handler
    >
      {text}
    </button>
  );
}

Button.propTypes = {
  variant: PropTypes.oneOf(["primary", "secondary"]).isRequired,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func, // Accept the onClick prop
};

Button.defaultProps = {
  onClick: null, // Default to no-op if not provided
};

Header.propTypes = {
  activeLink: PropTypes.string.isRequired,
};

export default Header;
